import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Clock, DollarSign, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Pricing = () => {
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const response = await axios.get(`${API}/pricing`);
        setPricing(response.data);
      } catch (error) {
        console.error('Error fetching pricing:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPricing();
  }, []);

  if (loading) {
    return (
      <section id="pricing" className="py-20 bg-gradient-to-b from-amber-50/30 to-white">
        <div className="container mx-auto px-4 flex justify-center items-center min-h-[400px]">
          <Loader2 className="w-8 h-8 animate-spin text-amber-800" />
        </div>
      </section>
    );
  }

  return (
    <section id="pricing" className="py-20 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Pricing
          </h2>
          <p className="text-xl text-gray-600">
            Transparent pricing for quality braiding services
          </p>
          <p className="text-sm text-gray-500 mt-2">
            *Prices may vary based on hair length and thickness
          </p>
        </div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {pricing.map((item) => (
            <Card key={item.id} className="border-2 hover:border-amber-800 hover:shadow-xl transition-all duration-300">
              <CardHeader className="bg-gradient-to-br from-amber-800 to-amber-900 text-white">
                <CardTitle className="text-2xl">{item.category}</CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <div className="space-y-4">
                  {item.sizes.map((size, index) => (
                    <div 
                      key={index}
                      className="pb-4 border-b last:border-b-0 last:pb-0"
                    >
                      <div className="flex justify-between items-start mb-2">
                        <span className="font-semibold text-gray-900">{size.size}</span>
                        <span className="text-amber-800 font-bold">{size.price}</span>
                      </div>
                      <div className="flex items-center text-sm text-gray-600">
                        <Clock className="w-4 h-4 mr-1" />
                        <span>{size.duration}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-12 max-w-4xl mx-auto">
          <Card className="bg-amber-50 border-amber-200">
            <CardContent className="p-6">
              <div className="flex items-start space-x-3">
                <DollarSign className="w-6 h-6 text-amber-800 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Pricing Information</h3>
                  <ul className="text-gray-700 space-y-1 text-sm">
                    <li>• All prices are in Swiss Francs (CHF)</li>
                    <li>• <strong>Hair extensions NOT included</strong> - You can purchase quality braiding hair from us or bring your own</li>
                    <li>• Mobile service available — an additional travel fee applies depending on your location</li>
                    <li>• Home studio location: Zollikerberg, Zurich</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
